<template>
    <div class="search_nav">
        <el-button type="primary" @click="addConfig">新增配置</el-button>
    </div>

    <el-table class="table_wrapper" :data="tableData" :header-cell-style="{'text-align':'left'}" :cell-style="{'text-align':'left'}">
        <el-table-column label="ID" width="80">
            <template #default="scope">
                <span>{{ scope.row.id || '-' }}</span>
            </template>
        </el-table-column>
        <el-table-column label="前缀">
            <template #default="scope">
                <span>{{ scope.row.prefix || '-' }}</span>
            </template>
        </el-table-column>
        <el-table-column label="商户编号" show-overflow-tooltip>
            <template #default="scope">
                <span>{{ scope.row.merchantNo || '-' }}</span>
            </template>
        </el-table-column>
        <el-table-column label="二维码规则" width="120">
            <template #default="scope">
                <span>{{ scope.row.rule === 0 ? 'hlht' : scope.row.rule === 1 ? 'https' : '-' }}</span>
            </template>
        </el-table-column>
        <el-table-column label="默认配置" width="100">
            <template #default="scope">
                <el-tag :type="scope.row.isDefault === 1 ? 'success' : 'info'">
                    {{ scope.row.isDefault === 1 ? '是' : '否' }}
                </el-tag>
            </template>
        </el-table-column>
        <el-table-column label="创建时间" width="180">
            <template #default="scope">
                <span>{{ scope.row.createTime || '-' }}</span>
            </template>
        </el-table-column>
        <el-table-column label="更新时间" width="180">
            <template #default="scope">
                <span>{{ scope.row.updateTime || '-' }}</span>
            </template>
        </el-table-column>
        <el-table-column label="操作" width="280" fixed="right">
            <template #default="scope">
                <el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>
                <el-button type="text" @click="handleDelete(scope.row)">删除</el-button>
                <el-button type="text" v-if="scope.row.isDefault !== 1" @click="handleSetDefault(scope.row)">设为默认</el-button>
            </template>
        </el-table-column>
    </el-table>

    <!-- 分页 -->
    <Pagination
        v-model:current-page="currentPage"
        v-model:page-size="pageSize"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
    />

    <!-- 新增/编辑配置弹窗 -->
    <el-dialog v-model="showModal" :title="isEdit ? '编辑二维码配置' : '新增二维码配置'" :close-on-click-modal="false" width="600px" @closed="$refs.configFormRef?.clearValidate()">
        <el-form ref="configFormRef" :model="configForm" :rules="configRules" label-width="120px">
            <el-form-item label="二维码规则">
                <el-radio-group v-model="configForm.rule">
                    <el-radio :label="0">hlht</el-radio>
                    <el-radio :label="1">https</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item v-if="configForm.rule === 1" label="前缀" prop="prefix">
                <el-input v-model="configForm.prefix" placeholder="请输入完整地址（如：https://example.com）"></el-input>
            </el-form-item>
            <el-form-item v-if="configForm.rule === 0" label="商户编号" prop="merchantNo">
                <el-input v-model="configForm.merchantNo" placeholder="请输入商户编号"></el-input>
            </el-form-item>
            <el-form-item label="是否默认配置">
                <el-select v-model="configForm.isDefault" placeholder="请选择">
                    <el-option label="否" :value="0"></el-option>
                    <el-option label="是" :value="1"></el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <template #footer>
            <el-button @click="showModal = false">取消</el-button>
            <el-button type="primary" @click="saveConfig">保存</el-button>
        </template>
    </el-dialog>
</template>

<script>
import { ElMessage, ElMessageBox } from 'element-plus';
import { required, isUrl, isAlphanumeric, maxLength } from '@/utils/validators';

export default {
    name: 'QrcodeConfig',
    data() {
        return {
            tableData: [],
            total: 0,
            currentPage: 1,
            pageSize: 10,
            showModal: false,
            isEdit: false,
            configRules: {
                prefix: [required('请输入前缀'), isUrl('请输入正确的网址格式（如：https://example.com）')],
                merchantNo: [required('请输入商户编号'), isAlphanumeric('商户编号只能输入数字和字母'), maxLength(30, '商户编号最长30个字符')]
            },
            configForm: {
                id: '',
                prefix: '',
                merchantNo: '',
                rule: '',
                isDefault: 0,
                tenantId: ''
            }
        }
    },
    mounted() {
        this.getList();
    },
    methods: {
        // 获取列表数据
        getList() {
            let that = this;
            let param = {
                page: that.currentPage,
                pageSize: that.pageSize
            };
            that.$axios.post(that.$store.state.platformApi + "qrcode/page", JSON.stringify(param)).then(result => {
                if (result.code == 200) {
                    that.tableData = result.data.records;
                    that.total = result.data.total;
                }
            });
        },
        // 新增配置
        addConfig() {
            this.isEdit = false;
            this.configForm = {
                id: '',
                prefix: '',
                merchantNo: '',
                rule: 1,
                isDefault: 0,
                tenantId: ''
            };
            this.showModal = true;
        },
        // 编辑配置
        handleEdit(row) {
            this.isEdit = true;
            this.configForm = {
                id: row.id,
                prefix: row.prefix || '',
                merchantNo: row.merchantNo || '',
                rule: row.rule,
                isDefault: row.isDefault,
                tenantId: row.tenantId || ''
            };
            this.showModal = true;
        },
        // 保存配置
        saveConfig() {
            let that = this;
            this.$refs.configFormRef.validate((valid) => {
                if (!valid) return;
                const url = this.isEdit ? 'qrcode/update' : 'qrcode/add';
                const submitData = { ...this.configForm };
                that.$axios.post(that.$store.state.platformApi + url, JSON.stringify(submitData)).then(result => {
                    if (result.code == 200) {
                        ElMessage.success(this.isEdit ? '编辑成功' : '新增成功');
                        that.showModal = false;
                        that.getList();
                    }
                });
            });
        },
        // 删除配置
        handleDelete(row) {
            let that = this;
            ElMessageBox.confirm('确定要删除该配置吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                that.$axios.post(that.$store.state.platformApi + 'qrcode/delete/' + row.id, {}).then(result => {
                    if (result.code == 200) {
                        ElMessage.success('删除成功');
                        that.getList();
                    }
                });
            }).catch(() => {});
        },
        // 设置为默认配置
        handleSetDefault(row) {
            let that = this;
            ElMessageBox.confirm('确定要将该配置设为默认配置吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                that.$axios.post(that.$store.state.platformApi + 'qrcode/set/default/' + row.id, {}).then(result => {
                    if (result.code == 200) {
                        ElMessage.success('设置成功');
                        that.getList();
                    }
                });
            }).catch(() => {});
        },
        // 分页相关
        handleSizeChange(val) {
            this.pageSize = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getList();
        }
    }
}
</script>

<style scoped>
.search_nav {
    margin-bottom: 20px;
}
.table_wrapper {
    margin-bottom: 20px;
}
</style>